import CrudTable from './CrudTable';
import { endpoints } from '../../services/api';

const Shippers = () => {
  return (
    <CrudTable
      title="Shippers"
      apiEndpoint={endpoints.oficina.shippers}
      columns={[
        { key: 'nombre', label: 'Nombre' },
        { key: 'direccion', label: 'Dirección' }
      ]}
      formFields={[
        { name: 'nombre', label: 'Nombre', required: true },
        { name: 'direccion', label: 'Dirección', type: 'textarea' }
      ]}
    />
  );
};

export default Shippers;

